import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Divider, Icon, Menu, MenuItem, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { optionsAccountMenu } from './headerHelpers';
import { useMyDetailQuery } from '../../services/controllers/user/UserQueries';

const OptionsHeader: React.FC = () => {
  const navigate = useNavigate();

  const [accountAnchorEl, setAccountAnchorEl] = useState<null | HTMLElement>(null);
  const openMenuAccount = Boolean(accountAnchorEl);

  const { data: userProfile } = useMyDetailQuery();

  const handleClickMenuAccount = (event: React.MouseEvent<HTMLElement>) => {
    setAccountAnchorEl(event.currentTarget);
  };

  const handleOptionMenuClick = (option: { link: string }) => {
    setAccountAnchorEl(null);
    navigate(option.link);
  };

  const handleCloseMenuAccount = () => {
    setAccountAnchorEl(null);
  };

  return userProfile ? (
    <div>
      <ItemHeader onClick={handleClickMenuAccount}>
        <Typography>{userProfile?.username ? `Xin chào, ${userProfile?.username}` : ''}</Typography>
        <KeyboardArrowDownIcon />
      </ItemHeader>
      <MenuAccount anchorEl={accountAnchorEl} open={openMenuAccount} onClose={handleCloseMenuAccount}>
        {optionsAccountMenu.map((option) => (
          <div key={option.title}>
            <MenuItem onClick={() => handleOptionMenuClick(option)}>
              <Icon component={option.iconOutlined} />
              <OptionTitle>{option.title}</OptionTitle>
            </MenuItem>
            {option.divider && <MenuDivider />}
          </div>
        ))}
      </MenuAccount>
    </div>
  ) : null;
};

export const ItemHeader = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  height: 52,
  color: theme.palette.primary.contrastText,
  marginLeft: 12,
  '& .MuiTypography-root': {
    margin: '0 5px 0 8px',
    fontSize: 15,
    fontWeight: 600,
  },
}));

const MenuAccount = styled(Menu)({
  '& .MuiPaper-root': {
    width: '190px',
  },
});

const OptionTitle = styled(Typography)({
  margin: '0 16px 0 8px',
  fontSize: 15,
});

const MenuDivider = styled(Divider)({
  margin: 0,
});

export default OptionsHeader;
